import React from "react";
import ChartistGraph from "react-chartist";
import Marker from "./Marker/Marker";

import GoogleMapReact from 'google-map-react';
import Footer from "components/Footer/Footer";
import Admin from "layouts/Admin";

import Background from 'assets/img/a.jpg';


import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";

// react-bootstrap components
import {
  Badge,
  Button,
  Card,
  Navbar,
  Nav,
  Table,
  Container,
  Row,
  Col,
  Form,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";

function Dashboard() {

  const getMapOptions = (maps: any) => {
    return {
      disableDefaultUI: true,
      mapTypeControl: true,
      streetViewControl: true,
      styles: [{ featureType: 'poi', elementType: 'labels', stylers: [{ visibility: 'on' }] }],
    };
  };

 
  return (

    <>

    <Admin/>

<br/>


<Container>

  <Row>
    <Col md={{ span: 12, offset: 1 }}>  

 
 
      <Container fluid>
        <Row>
          <Col lg="3" sm="6">
            <Card className="card-stats">
              <Card.Body>
                <Row>
                  <Col xs="5">
                    <div className="icon-big text-center icon-warning">
                      <i className="	fas fa-car-side"></i>
                    </div>
                  </Col>
                  <Col xs="7">
                    <div className="numbers">
                      <p className="card-category">Active Vehicles</p>
                      <Card.Title as="h4">15</Card.Title>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
              <Card.Footer>
                <hr></hr>
                <div className="stats">
                  <i className="fas fa-redo mr-1"></i>
                  Update Now
                </div>
              </Card.Footer>
            </Card>
          </Col>
       
          <Col lg="3" sm="6">
            <Card className="card-stats">
              <Card.Body>
                <Row>
                  <Col xs="5">
                    <div className="icon-big text-center icon-warning">
                      <i className="fas fa-wheelchair"></i>
                    </div>
                  </Col>
                  <Col xs="7">
                    <div className="numbers">
                      <p className="card-category">Drivers</p>
                      <Card.Title as="h4">28</Card.Title>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
              <Card.Footer>
                <hr></hr>
                <div className="stats">
                  <i className="fas fa-redo mr-1"></i>
                  Update now
                </div>
              </Card.Footer>
            </Card>
          </Col>


          <Col lg="3" sm="6">
            <Card className="card-stats">
              <Card.Body>
                <Row>
                  <Col xs="5">
                    <div className="icon-big text-center icon-warning">
                      <i className="fas fa-wheelchair"></i>
                    </div>
                  </Col>
                  <Col xs="7">
                    <div className="numbers">
                      <p className="card-category">Drivers</p>
                      <Card.Title as="h4">28</Card.Title>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
              <Card.Footer>
                <hr></hr>
                <div className="stats">
                  <i className="fas fa-redo mr-1"></i>
                  Update now
                </div>
              </Card.Footer>
            </Card>
          </Col>

         




        </Row>
        <Row>
          <Col md="11">
            <Card>
              <Card.Header>
                <Card.Title as="h4">Trip Behavior</Card.Title>
                <p className="card-category">24 Hours</p>
              </Card.Header>
              <Card.Body>

<Container>

<div style={{ height: '100vh', width: '100%' }}>

<GoogleMapReact

defaultCenter={{ lat: 6.88388123339369, lng: 79.90902221680786 }}




// defaultOptions={{
//   // defaultCenter: {lat: -34.397, lng: 150.644 },
//   disableDefaultUI: true,
//   mapTypeId: google.maps.MapTypeId.SATELLITE,//google.maps.MapTypeId.TERRAIN,
// }}

defaultZoom={16}

yesIWantToUseGoogleMapApiInternals

// onGoogleApiLoaded={({ map, maps }) => renderMarkers(map, maps)}

bootstrapURLKeys={{

    // key:'AIzaSyDx_OOD2uFzawFZxj_fXWEM_y7omzZnGGY',
    key:'',

    language: 'en',
    

}}

options={getMapOptions}

>

  


      <Marker
            lat={6.88388123339369}
            lng={79.90902221680786}
            name="My Marker"
            color="blue"
          />



</GoogleMapReact>

</div>

              
</Container>

                
              </Card.Body>
            
            </Card>
          </Col>
          
        </Row>
        <Row>
        
        </Row>
      </Container>

      </Col>
  </Row>

  
</Container>


<Footer /> 



    </>


    
  );
}

export default Dashboard;
